/* eslint-disable comma-dangle */
/* eslint-disable function-paren-newline */
/* eslint-disable no-unused-vars */
/* eslint-disable  implicit-arrow-linebreak */
import styled from "styled-components";
import { Input, Select, DatePicker } from "antd";
import Colors from "../../config/Colors";

export const WINDOW_WIDTH = window.innerWidth;
export const WINDOW_HEIGHT = window.innerHeight;

export const InformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

// Summary Cards Styles
export const SummaryCardsWithExportContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-bottom: 16px;
  justify-content: space-between;
  padding: 0px 16px;
`;

export const SummaryCardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const SummaryCard = styled.div`
  width: 386px;
  border-radius: 8px;
  border: 1px solid #ffffff;
  background: #ffffff;
  padding: 16px;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
  margin-top: 8px;
`;

export const CardTitle = styled.p`
  font-weight: 500;
  font-size: 16px;
  font-style: normal;
  color: #515151;
  line-height: 27px;
  height: 27px;
  margin: 0;
  text-align: left;
`;

export const CardIconContainer = styled.div<{ backgroundColor?: string }>`
  background-color: ${(props) => props.backgroundColor || "#e6fdc7"};
  border-radius: 5px;
  width: 20px;
  height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  margin-top: 8px;
`;

export const CardValue = styled.p`
  font-weight: 700;
  font-size: 24px;
  color: #515151;
  margin: 0;
  line-height: 27px;
  height: 27px;
  text-align: left;
`;

export const CardDescription = styled.p`
  font-weight: 400;
  font-size: 12px;
  color: #515151;
  margin: 0;
  height: 27px;
  text-align: left;
`;

// Companies Panel Styles
export const CompaniesPanel = styled.div`
  width: 531px;
  border-radius: 12px;
  background: #ffffff;
  padding: 20px;
  border: 1px solid #eaecf0;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
`;

export const CompaniesPanelContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const CompaniesPanelHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const PanelTitle = styled.p`
  font-weight: 600;
  font-size: 18px;
  font-style: normal;
  color: #101828;
  line-height: 28px;
  text-align: left;
  margin: 0;
`;

export const SearchFilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
`;

export const StyledSearch = styled(Input.Search)`
  width: 388px;
  border-radius: 10px;
  background: #f8f8f8;

  .ant-input {
    background: #f8f8f8;
  }
`;

export const SelectWithPrefixIcon = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 110px;

  .prefix-icon {
    position: absolute;
    left: 11px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    color: rgba(0, 0, 0, 0.45);
    pointer-events: none;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  border-radius: 4px;

  .ant-select-selector {
    padding-left: 28px !important;
    padding-right: 8px !important;
  }

  .ant-select-arrow {
    display: none;
  }
`;

export const StatusFilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  color: #344054;
  transition: all 0.2s ease;

  &:hover {
    background: #f9fafb;
    border-color: #98a2b3;
  }

  &:active {
    background: #f2f4f7;
  }
`;

export const ResultsText = styled.p`
  font-weight: 500;
  font-size: 15px;
  color: #344054;
  margin: 0;
  line-height: 22px;
  text-align: left;
`;

export const CompaniesListContainer = styled.div`
  height: 477px;
  background-color: #f9fafb;
  border-radius: 12px;
  padding: 12px;
  overflow-y: auto;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #d0d5dd;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #98a2b3;
  }
`;

export const CompaniesListContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const CompanyItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: white;
  border-radius: 12px;
  padding: 12px 16px;
  box-sizing: border-box;
  margin-bottom: 12px;
  gap: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const CompanyInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const CompanyLogo = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background-color: #f2f4f7;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
  }
`;

export const CompanyDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  align-items: flex-start;
  text-align: left;
`;

export const CompanyName = styled.span`
  font-weight: 500;
  font-size: 16px;
  color: #101828;
  line-height: 24px;
  display: block;
  text-align: left;
`;

export const StatusBadge = styled.div<{
  isActive?: boolean;
  isSuspended?: boolean;
}>`
  background-color: ${(props) =>
    props.isActive ? "#d1fadf" : props.isSuspended ? "#fee4e2" : "#f2f4f7"};
  border-radius: 16px;
  padding: 2px 10px;
  display: inline-flex;
  width: fit-content;
  align-items: center;
  justify-content: flex-start;
`;

export const StatusText = styled.span<{
  isActive?: boolean;
  isSuspended?: boolean;
}>`
  font-weight: 500;
  font-size: 12px;
  color: ${(props) =>
    props.isActive ? "#027a48" : props.isSuspended ? "#b42318" : "#475467"};
  line-height: 18px;
  text-align: left;
`;

export const ViewInvoicesButton = styled.button`
  background-color: #3d5a99;
  border: none;
  width: 120px;
  height: 38px;
  border-radius: 6px;
  padding: 10px 14px;
  gap: 10px;
  cursor: pointer;
  font-weight: 500;
  font-size: 15px;
  color: #ffffff;
  white-space: nowrap;
  transition: all 0.2s ease;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  &:hover {
    background-color: #2d4575;
  }

  &:active {
    background-color: #1f3054;
  }
`;

// Chart Panel Styles
export const ChartPanel = styled.div`
  width: 950px;
  height: 400px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid #eaecf0;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ChartHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 28px 33px;
  border-bottom: 1px solid #e9e9e9;
  gap: 20px;
`;

export const ChartHeaderLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const ChartTitle = styled.p`
  font-weight: 600;
  font-size: 20px;
  color: #080808;
  margin: 0;
  line-height: 28px;
  letter-spacing: -0.2px;
  font-style: normal;
`;

export const ChartFilterContainer = styled.div`
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  box-sizing: border-box;
`;

export const ChartFilterText = styled.span`
  font-weight: 400;
  font-size: 15px;
  line-height: 28px;
  letter-spacing: -0.15px;
  color: #0f172a;
`;

export const ChartFilterValue = styled.span`
  font-weight: 500;
  font-size: 15px;
  line-height: 28px;
  letter-spacing: -0.15px;
  color: #0f172a;
`;

export const ChartContent = styled.div`
  flex: 1;
  padding: 0 33px 20px 33px;
  position: relative;
  min-height: 0;
  overflow: hidden;
`;

export const ChartContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  height: 100%;
  min-height: 0;
  padding-top: 20px;
  align-items: flex-start;
`;

export const YAxisLabels = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 14.444px;
  height: 248.466px;
  margin-top: 0;
  font-weight: 500;
  font-size: 10px;
  color: #464646;
  line-height: 14px;
  letter-spacing: -0.5px;
`;

export const ChartArea = styled.div`
  flex: 1;
  height: 100%;
  min-height: 0;
  margin-left: 20px;
  margin-top: 0;
  position: relative;
`;

export const XAxisLabels = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: absolute;
  bottom: -40px;
  left: 0;
  right: 0;
  font-weight: 500;
  font-size: 10px;
  color: #515151;
  padding-top: 32px;
  line-height: normal;
  letter-spacing: 0;
  height: 10px;
  gap: 34px;
`;

export const LegendContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin-left: 20px;
  margin-top: 24px;
  width: 206px;
`;

export const LegendItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const LegendColor = styled.div<{ color: string }>`
  width: 12px;
  height: 12px;
  background-color: ${(props) => props.color};
  border-radius: 2px;
  flex-shrink: 0;
`;

export const LegendText = styled.span`
  font-weight: 500;
  font-size: 16px;
  color: #878787;
  line-height: 24px;
  letter-spacing: 0;
  width: 198px;
  text-align: left;
`;

// Modal Styles
export const ModalContentWrapper = styled.div`
  padding: 28px 32px;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const ModalTitle = styled.h2`
  font-weight: 700;
  font-size: 28px;
  color: #515151;
  margin: 0;
`;

export const ModalSearchFilterContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 20px;
`;

export const ModalSearchInput = styled(Input.Search)`
  flex: 1;
  border-radius: 10px;
  background: #f8f8f8;

  .ant-input-wrapper {
    height: 40px;
  }

  .ant-input-affix-wrapper {
    height: 40px !important;
    background: #f8f8f8;
    border-radius: 10px;
    padding: 0 15px;
  }

  .ant-input {
    background: #f8f8f8;
    height: 40px !important;
    font-size: 15px;
  }

  .ant-input-prefix {
    margin-right: 10px;

    span {
      font-size: 18px !important;
    }

    svg {
      font-size: 18px;
      width: 18px;
      height: 18px;
    }
  }

  .ant-input-suffix {
    font-size: 15px;
  }
`;

export const ModalMonthSelect = styled(Select)`
  width: 140px;
  height: 40px;
  border-radius: 4px;

  .ant-select-selector {
    height: 40px !important;
    font-size: 15px;
  }

  .ant-select-selection-item {
    line-height: 40px !important;
  }
`;

export const ModalYearSelect = styled(Select)`
  width: 120px;
  height: 40px;
  border-radius: 4px;

  .ant-select-selector {
    height: 40px !important;
    font-size: 15px;
  }

  .ant-select-selection-item {
    line-height: 40px !important;
  }
`;

export const InvoiceListContainer = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  background-color: #f6f6f6;
  border-radius: 8px;
  padding: 12px;
`;

export const InvoiceListContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const InvoiceItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: white;
  border-radius: 10px;
  padding: 20px 16px;
`;

export const InvoiceInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const InvoiceNumber = styled.span`
  font-weight: 500;
  font-size: 20px;
  color: #000000;
`;

export const InvoiceDateContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const InvoiceDate = styled.span`
  font-weight: 400;
  font-size: 14px;
  color: #000000;
`;

export const InvoiceActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const InvoiceActionButton = styled.button`
  background-color: transparent;
  border: 1px solid #3d5a99;
  width: 44px;
  height: 38px;
  border-radius: 6px;
  padding: 8px;
  cursor: pointer;
  font-size: 18px;
  color: #3d5a99;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f0f4ff;
    border-color: #2d4575;
    color: #2d4575;
  }

  &:active {
    background-color: #e0e8ff;
    border-color: #1f3054;
    color: #1f3054;
  }
`;

// Invoice Detail Modal Styles
export const InvoiceDetailWrapper = styled.div`
  padding: 32px;
`;

export const InvoiceDetailHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
`;

export const InvoiceDetailBackButton = styled.button`
  border: none;
  padding: 0;
  height: auto;
  background: transparent;
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
  color: #515151;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    color: #1757a2;
  }
`;

export const InvoiceDetailDownloadButton = styled.button`
  background-color: #1757a2;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background-color: #124278;
  }

  &:active {
    background-color: #0d3159;
  }
`;

export const PDFViewerContainer = styled.div`
  width: 100%;
  height: calc(80vh - 100px);
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e9e9e9;
`;

export const InvoiceDetailHeaderSection = styled.div`
  margin-bottom: 32px;
`;

export const InvoiceDetailHeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
`;

export const InvoiceDetailTitleWrapper = styled.div``;

export const InvoiceDetailTitle = styled.h1`
  font-weight: 700;
  font-size: 24px;
  color: #080808;
  margin: 0 0 8px 0;
`;

export const InvoiceDetailSubtitle = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: #515151;
  margin: 0;
`;

export const InvoiceDetailLogo = styled.div`
  width: 120px;
  height: 40px;
  background-color: #1757a2;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-weight: 600;
  font-size: 16px;
`;

export const InvoiceInfoRow = styled.div`
  display: flex;
  gap: 48px;
  margin-bottom: 24px;
`;

export const InvoiceInfoItem = styled.div``;

export const InvoiceInfoLabel = styled.p`
  font-weight: 400;
  font-size: 12px;
  color: #7a7a7a;
  margin: 0 0 4px 0;
`;

export const InvoiceInfoValue = styled.p`
  font-weight: 500;
  font-size: 14px;
  color: #080808;
  margin: 0;
`;

export const BilledToSection = styled.div`
  margin-top: 24px;
`;

export const BilledToLabel = styled.p`
  font-weight: 600;
  font-size: 14px;
  color: #080808;
  margin: 0 0 8px 0;
`;

export const BilledToName = styled.p`
  font-weight: 500;
  font-size: 14px;
  color: #080808;
  margin: 0 0 4px 0;
`;

export const BilledToAddress = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: #515151;
  margin: 0;
`;

export const InvoiceTableContainer = styled.div`
  margin-bottom: 32px;
`;

export const InvoiceTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const InvoiceTableHeader = styled.thead`
  background-color: #080808;
  color: #ffffff;
`;

export const InvoiceTableHeaderCell = styled.th<{ textAlign?: string }>`
  padding: 12px 16px;
  text-align: ${(props) => props.textAlign || "left"};
  font-weight: 600;
  font-size: 12px;
`;

export const InvoiceTableBody = styled.tbody``;

export const InvoiceTableRow = styled.tr`
  border-bottom: 1px solid #e9e9e9;
`;

export const InvoiceTableCell = styled.td<{
  textAlign?: string;
  fontWeight?: number;
}>`
  padding: 16px;
  text-align: ${(props) => props.textAlign || "left"};
  font-weight: ${(props) =>
    props.fontWeight !== undefined ? props.fontWeight : 400};
  font-size: 14px;
  color: #080808;
`;

export const InvoiceTotalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 24px;
  border-top: 2px solid #e9e9e9;
  margin-bottom: 32px;
`;

export const InvoiceTotalLabel = styled.span`
  font-weight: 600;
  font-size: 16px;
  color: #080808;
`;

export const InvoiceTotalValue = styled.span`
  font-weight: 700;
  font-size: 20px;
  color: #080808;
`;

export const ContactInfoContainer = styled.div`
  padding-top: 24px;
  border-top: 1px solid #e9e9e9;
`;

export const ContactInfoTitle = styled.p`
  font-weight: 600;
  font-size: 14px;
  color: #080808;
  margin: 0 0 8px 0;
`;

export const ContactInfoText = styled.p`
  font-weight: 400;
  font-size: 12px;
  color: #515151;
  margin: 0;
`;

// Pagination Styles
export const PaginationContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
`;

export const PaginationButton = styled.button<{
  isActive?: boolean;
  isDisabled?: boolean;
}>`
  background: ${(props) => (props.isActive ? "#3d5a99" : "#FFFFFF")};
  border: ${(props) => (props.isActive ? "none" : "1px solid #d0d5dd")};
  border-radius: 8px;
  padding: 8px 14px;
  min-width: 40px;
  cursor: ${(props) => (props.isDisabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.isDisabled ? 0.5 : 1)};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  box-sizing: border-box;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: ${(props) => (props.isActive ? "#2d4575" : "#f9fafb")};
    border-color: ${(props) => (props.isActive ? "none" : "#98a2b3")};
  }

  &:active:not(:disabled) {
    background: ${(props) => (props.isActive ? "#1f3054" : "#f2f4f7")};
  }
`;

export const PaginationButtonText = styled.span<{ isActive?: boolean }>`
  font-size: 14px;
  font-weight: ${(props) => (props.isActive ? 600 : 500)};
  color: ${(props) => (props.isActive ? "#FFFFFF" : "#344054")};
  line-height: 20px;
`;

// Helper Components
export const MainContentArea = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;
  padding: 0 16px;
`;

export const CenteredSpinner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

export const CenteredEmpty = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

export const EmptyStateText = styled.span`
  font-weight: 500;
  font-size: 15px;
  color: #667085;
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 20px 20px;
  text-align: center;
`;

export const EmptyStateContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-top: 24px;
`;

export const EmptyStateIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0;
`;

export const EmptyStateTitle = styled.h3`
  font-weight: 600;
  font-size: 18px;
  color: #101828;
  margin: 0;
  line-height: 28px;
`;

export const EmptyStateDescription = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: #667085;
  margin: 0;
  line-height: 20px;
  max-width: 400px;
  text-align: center;
`;

export const InvoiceItemsEmptyCell = styled.td`
  padding: 32px;
  text-align: center;
  color: #667085;
  font-weight: 400;
  font-size: 14px;
`;

// Y-axis Label Spans
export const YAxisLabelSpan = styled.span<{ marginTop?: string }>`
  margin-top: ${(props) => props.marginTop || "0"};
`;

// X-axis Label Spans
export const XAxisLabelSpan = styled.span<{ width?: string }>`
  width: ${(props) => props.width || "auto"};
`;

// Search Icon Styles
export const SearchIconWrapper = styled.span`
  color: #9b9b9b;
  font-size: 18px;
  display: flex;
  align-items: center;
`;

export const InfoIconWrapper = styled.span`
  color: #515151;
  font-size: 20px;
`;

export const CalendarIconWrapper = styled.span`
  font-size: 18px;
  color: #323232;
  display: flex;
  align-items: center;
`;

// Billing Data Export Modal Styles
export const BillingExportWrapper = styled.div`
  padding: 22px 29px 39px 29px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const BillingExportHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BillingExportHeaderTop = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`;

export const BillingExportCloseButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: #0f172b;

  &:hover {
    opacity: 0.7;
  }
`;

export const BillingExportTitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
  align-items: flex-start;
`;

export const BillingExportTitle = styled.h1`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #0f172b;
  margin: 0;
  letter-spacing: -0.3125px;
  text-align: left;
`;

export const BillingExportDescription = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #45556c;
  margin: 0;
  letter-spacing: -0.3125px;
  text-align: left;
`;

export const BillingExportCard = styled.div`
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 14px;
  padding: 1px;
  display: flex;
  flex-direction: column;
`;

export const BillingExportCardHeader = styled.div`
  padding: 24px 24px 0 24px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const BillingExportCardTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #0f172a;
  letter-spacing: -0.3125px;
  text-align: left;
`;

export const BillingExportCardIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BillingExportCardDescription = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #717182;
  margin: 0;
  letter-spacing: -0.3125px;
  text-align: left;
`;

export const BillingExportCardContent = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const BillingExportField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const BillingExportLabel = styled.label`
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: #0f172a;
  letter-spacing: -0.1504px;
  text-align: left;
`;

export const BillingExportSelect = styled(Select)`
  width: 100%;
  height: 51px;

  .ant-select-selector {
    height: 51px !important;
    border: 1px solid #1757a2 !important;
    border-radius: 4px !important;
    padding: 0 15px !important;
    display: flex;
    align-items: center;
  }

  .ant-select-selection-placeholder {
    font-weight: 400;
    font-size: 16px;
    color: #9b9b9b;
    line-height: 51px;
  }

  .ant-select-selection-item {
    font-weight: 400;
    font-size: 16px;
    color: #0f172a;
    line-height: 51px;
  }
`;

export const BillingExportCompanyDropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const BillingExportCompanySelectButton = styled.button<{
  $isOpen: boolean;
}>`
  width: 100%;
  height: 51px;
  border: 1px solid #1757a2;
  border-radius: 4px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  cursor: pointer;
  font-weight: 400;
  font-size: 16px;
  color: ${(props) => (props.$isOpen ? "#0f172a" : "#9b9b9b")};
  transition: all 0.2s ease;

  &:hover {
    border-color: #124278;
  }

  &:focus {
    outline: none;
    border-color: #1757a2;
  }
`;

export const BillingExportCompanySelectText = styled.span`
  font-weight: 400;
  font-size: 16px;
  color: #0f172a;
  text-align: left;
  flex: 1;
`;

export const BillingExportCompanyDropdown = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.1),
    0px 2px 4px -1px rgba(0, 0, 0, 0.06);
  z-index: 1000;
  padding: 8px;
  max-height: 300px;
  overflow-y: auto;
`;

export const BillingExportCompanySearchWrapper = styled.div`
  margin-bottom: 12px;
`;

export const BillingExportCompanySearchInput = styled(Input)`
  width: 100%;
  height: 32px;
  background: #f8f8f8;
  border: none;
  border-radius: 10px;
  padding: 8px 12px;
  font-weight: 400;
  font-size: 12px;
  color: #000;

  &::placeholder {
    color: #9b9b9b;
  }

  .ant-input {
    background: #f8f8f8;
  }

  .ant-input-prefix {
    margin-right: 8px;
    color: #9b9b9b;
  }
`;

export const BillingExportCompanyList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BillingExportCompanyItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 22px;

  .ant-checkbox {
    .ant-checkbox-inner {
      width: 16px;
      height: 16px;
      border-radius: 4px;
      border: 1px solid #1757a2;
    }

    &.ant-checkbox-checked .ant-checkbox-inner {
      background-color: #1757a2;
      border-color: #1757a2;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
    }

    .ant-checkbox-inner::after {
      width: 5px;
      height: 8px;
      border: 2px solid #fff;
      border-top: 0;
      border-left: 0;
      left: 5px;
      top: 6px;
    }
  }
`;

export const BillingExportCompanyBadge = styled.span`
  background-color: transparent;
  color: #314158;
  border-radius: 8px;
  padding: 3px 0;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const BillingExportDateRow = styled.div`
  display: flex;
  gap: 20px;
`;

export const BillingExportDateField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
`;

export const BillingExportDateButtonWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const BillingExportDateSelectButton = styled.button<{
  $isOpen: boolean;
}>`
  width: 100%;
  height: 51px;
  border: 1px solid #1757a2;
  border-radius: 4px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: white;
  cursor: pointer;
  font-weight: 400;
  font-size: 16px;
  color: ${(props) => (props.$isOpen ? "#0f172a" : "#9b9b9b")};
  transition: all 0.2s ease;

  &:hover {
    border-color: #124278;
  }

  &:focus {
    outline: none;
    border-color: #1757a2;
  }
`;

export const BillingExportDateSelectText = styled.span`
  font-weight: 400;
  font-size: 16px;
  color: #0f172a;
  text-align: left;
  flex: 1;
`;

export const BillingExportHiddenDatePicker = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 51px;
  z-index: 2;
  pointer-events: none;

  .ant-picker {
    width: 100%;
    height: 51px;
    border: none !important;
    background: transparent !important;
    padding: 0 !important;
    box-shadow: none !important;

    .ant-picker-input {
      height: 51px;
      opacity: 0;
      pointer-events: auto;
      cursor: pointer;
    }

    .ant-picker-suffix {
      display: none;
    }
  }
`;

export const BillingExportDatePickerWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  svg {
    position: absolute;
    left: 12px;
    z-index: 1;
    pointer-events: none;
  }
`;

export const BillingExportDatePicker = styled(DatePicker)`
  width: 100%;
  border: none !important;
  box-shadow: none !important;

  .ant-picker-input {
    height: auto;
    padding: 0;
  }

  .ant-picker-input > input {
    font-weight: 400;
    font-size: 16px;
    color: #0f172a;
  }

  .ant-picker-suffix {
    display: none;
  }
`;

export const BillingExportArrowIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: #0f172a;

  &::after {
    content: "▼";
    font-size: 12px;
  }
`;

export const BillingExportSubscriptionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BillingExportSubscriptionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  .ant-checkbox {
    .ant-checkbox-inner {
      width: 16px;
      height: 16px;
      border-radius: 4px;
      border: 1px solid #030213;
    }

    &.ant-checkbox-checked .ant-checkbox-inner {
      background-color: #030213;
      border-color: #030213;
    }

    .ant-checkbox-inner::after {
      width: 5px;
      height: 8px;
      border: 2px solid #fff;
      border-top: 0;
      border-left: 0;
      left: 5px;
      top: 6px;
    }
  }
`;

export const BillingExportBadge = styled.span<{
  badgeColor: string;
  textColor: string;
}>`
  background-color: ${(props) => props.badgeColor};
  color: ${(props) => props.textColor};
  border-radius: 8px;
  padding: 3px 9px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const BillingExportActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 17px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
`;

export const BillingExportButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BillingExportError = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #b42318;
  text-align: left;
  padding: 0 4px;
`;

export const BillingExportButton = styled.button`
  background-color: #1757a2;
  border: none;
  border-radius: 8px;
  height: 36px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: white;
  letter-spacing: -0.1504px;
  transition: background-color 0.2s ease;

  &:hover:not(:disabled) {
    background-color: #124278;
  }

  &:active:not(:disabled) {
    background-color: #0d3159;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const BillingExportResetButton = styled.button`
  background: transparent;
  border: none;
  border-radius: 8px;
  height: 36px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #0f172a;
  letter-spacing: -0.1504px;
  transition: color 0.2s ease;

  &:hover:not(:disabled) {
    color: #1757a2;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ExportButton = styled.button`
  background-color: #1757a2;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  display: flex;
  gap: 8px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  transition: background-color 0.2s ease;
  white-space: nowrap;
  align-self: flex-start;

  &:hover {
    background-color: #124278;
  }

  &:active {
    background-color: #0d3159;
  }
`;
